function initMedicineProducts() {
    const faqNotFound = document.querySelector(".medicine-products__qa-not-found");

    if (!faqNotFound) return;

    const askQuestionButton = faqNotFound.querySelector(".ask-question");

    askQuestionButton.addEventListener("click", () => window.openModal("#feedback-modal-common"));
}

window.onload = () => {
    initMedicineProducts();
}